const DEFAULT_USE_WEB_SOCKET = true;
/**
 * save and store appUseWebSocket in the localstorage
 * if true -> use websocket so realtime update will be on
 */
class AppWebSocket {
  static key = 'appUseWebSocket';
  static defaultUseWebSocket = DEFAULT_USE_WEB_SOCKET;
  static setUseWebSocket(val: boolean) {
    localStorage.setItem(AppWebSocket.key, JSON.stringify(val));
  }
  static getUseWebSocket() {
    const val = localStorage.getItem(AppWebSocket.key);
    return val ? JSON.parse(val) : AppWebSocket.defaultUseWebSocket;
  }
  static clearUserWebSocket() {
    localStorage.removeItem(AppWebSocket.key);
  }
}
export default AppWebSocket;
